import React from 'react';
import {useHistory, useParams} from 'react-router';
import classNames from 'classnames';
import {FocalImage} from 'lib/react-image-focus/FocalImage';

import styles from './ImageTile.module.css';
import {Image, ImageReviewCompletionEnum} from 'interfaces/models';
import {ImagesRoute, imagesRoute} from 'app/appRoutes';

interface Props {
    image: Image,
    idx: number,
    fetchingImages: boolean
}

const ImageTile = (props: Props) => {
    const {image, idx, fetchingImages} = props;
    const history = useHistory();
    const matchParams = useParams<ImagesRoute>();

    const handleClick = () => {
        history.push(imagesRoute(matchParams.filterId, matchParams.reviewedAfter, matchParams.page, idx));
    }

    const mapStyle = (completion: ImageReviewCompletionEnum): string => {
        switch (completion) {
            case ImageReviewCompletionEnum.ReviewedPartial:
                return styles.reviewedPartial;
            case ImageReviewCompletionEnum.Reviewed:
                return styles.reviewed;
            case ImageReviewCompletionEnum.NotReviewed:
            default:
                return styles.notReviewed;
        }
    }
    
    return <div className={classNames(styles.tile, mapStyle(image.reviewCompletion))} onClick={handleClick}>
        {!fetchingImages && <FocalImage src={image.originalUrl} focalPoint={{
            x: image.focalPointX,
            y: image.focalPointY,
            z: image.focalPointZ || 1
        }}/>}
    </div>;
};

export default ImageTile;